module.exports = __webpack_public_path__ + "static/media/icon_07.749d9dd1.png";